import React from 'react';
import './Sidebar.css';
import { NavLink, useNavigate } from 'react-router-dom';
import { LogOut, LayoutDashboard, FileText, Users, ShoppingBag, BarChart2, UserRoundCheck, Bell, Shield } from 'lucide-react';
import logoNorac from '../../assets/img/logo_norac.png';
import { useMenuActive } from '../../hooks/useMenuActive';

const Sidebar = ({ menuAberto, setMenuAberto }) => {
  const navigate = useNavigate();

  // Recuperar informações do usuário do localStorage
  const nomeUsuario = localStorage.getItem('nome_usuario') || 'Usuário';
  const emailUsuario = localStorage.getItem('email_usuario') || 'usuario@exemplo.com';
  const inicialNome = nomeUsuario.charAt(0).toUpperCase();

  const dashboardActive   = useMenuActive('/dashboard');
  const pedidosActive     = useMenuActive('/pedido');
  const clientesActive    = useMenuActive('/cliente');
  const aprovarActive     = useMenuActive('/aprovar-cliente');
  const comunicadosActive = useMenuActive('/comunicado');
  const perfisAcessoActive = useMenuActive('/perfis-acesso');

  const handleLogout = () => {
    // Confirmação antes de fazer logout
    const confirmarLogout = window.confirm('Tem certeza que deseja sair do sistema?');
    
    if (confirmarLogout) {
      // Remove o token do localStorage
      localStorage.removeItem('token');
      
      // Fecha o menu se estiver aberto
      setMenuAberto(false);
      
      // Feedback visual (opcional - pode ser removido se não quiser)
      console.log('Logout realizado com sucesso');
      
      // Redireciona para a página de login
      navigate('/login', { replace: true });
    }
  };

  return (
    <aside className={`sidebar ${menuAberto ? 'aberto' : ''}`}>
      <div className="sidebar-top">
        <img src={logoNorac} alt="Logo Norac" className="sidebar-logo-img" />
        <div className="sidebar-title">
          <span>Sistema de Pedidos</span>
        </div>
      </div>
      <nav className="sidebar-menu">
        <NavLink
          className={'menu-item' + (dashboardActive ? ' active' : '')}
          to="/dashboard"
          onClick={() => setMenuAberto(false)}
          end
        >
          <span className="icon"><LayoutDashboard size={20} /></span>
          <span className="label">Dashboard</span>
        </NavLink>
        <NavLink
          className={'menu-item' + (pedidosActive ? ' active' : '')}
          to="/pedidos"
          onClick={() => setMenuAberto(false)}
          end
        >
          <span className="icon"><FileText size={20} /></span>
          <span className="label">Pedidos</span>
        </NavLink>

        <NavLink
          className={'menu-item' + (clientesActive ? ' active' : '')}
          to="/clientes"
          onClick={() => setMenuAberto(false)}
          end
        >
          <span className="icon"><Users size={20} /></span>
          <span className="label">Clientes</span>
        </NavLink>


        <NavLink
          className={'menu-item' + (aprovarActive ? ' active' : '')}
          to="/aprovar-clientes"
          onClick={() => setMenuAberto(false)}
        >
          <span className="icon"><UserRoundCheck size={20} /></span>
          <span className="label">Aprovação de Clientes</span>
        </NavLink>


        <NavLink
          className={'menu-item' + (comunicadosActive ? ' active' : '')}
          to="/comunicados"
          onClick={() => setMenuAberto(false)}
        >
          <span className="icon"><Bell size={20} /></span>
          <span className="label">Comunicados</span>
        </NavLink>

        <NavLink
          className={'menu-item' + (perfisAcessoActive ? ' active' : '')}
          to="/perfis-acesso"
          onClick={() => setMenuAberto(false)}
        >
          <span className="icon"><Shield size={20} /></span>
          <span className="label">Perfis de Acesso</span>
        </NavLink>

      </nav>
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <div className="sidebar-avatar">{inicialNome}</div>
          <div>
            <div className="sidebar-user-name">{nomeUsuario}</div>
            <div className="sidebar-user-email">{emailUsuario}</div>
          </div>
        </div>
        <button className="sidebar-logout" onClick={handleLogout}>
          <LogOut size={15} style={{ marginRight: 5 }} />
          Sair
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;